"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractCustomerDataToJSON = exports.AbstractCustomerDataFromJSONTyped = exports.AbstractCustomerDataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function AbstractCustomerDataFromJSON(json) {
    return AbstractCustomerDataFromJSONTyped(json, false);
}
exports.AbstractCustomerDataFromJSON = AbstractCustomerDataFromJSON;
function AbstractCustomerDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'gender': !(0, runtime_1.exists)(json, 'gender') ? undefined : (0, _1.GenderFromJSON)(json['gender']),
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
    };
}
exports.AbstractCustomerDataFromJSONTyped = AbstractCustomerDataFromJSONTyped;
function AbstractCustomerDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'gender': (0, _1.GenderToJSON)(value.gender),
        'firstName': value.firstName,
        'lastName': value.lastName,
    };
}
exports.AbstractCustomerDataToJSON = AbstractCustomerDataToJSON;
//# sourceMappingURL=AbstractCustomerData.js.map